export default {
	KEY_ENTER: 13,
	KEY_LEFT: 37,
	KEY_UP: 38,
	KEY_RIGHT: 39,
	KEY_DOWN: 40,
	KEY_ESCAPE: 27,
	KEY_TAB: 9,
};